import React from 'react';
import { PageSection } from '../../../types';
import { PricingEditor } from './editors/PricingEditor';
import { HeroEditor } from './editors/HeroEditor';
import { ServicesEditor } from './editors/ServicesEditor';
import { AboutEditor } from './editors/AboutEditor';
import { ContactEditor } from './editors/ContactEditor';
import { YachtFleetEditor } from './editors/YachtFleetEditor';
import { YachtFilterEditor } from './editors/YachtFilterEditor';
import { FaqEditor } from './editors/FaqEditor';
import { TestimonialsEditor } from './editors/TestimonialsEditor';
import { GalleryEditor } from './editors/GalleryEditor';
import { StatsEditor } from './editors/StatsEditor';
import { TeamEditor } from './editors/TeamEditor';
import { ReferencesEditor } from './editors/ReferencesEditor';
import { ReservationCtaEditor } from './editors/ReservationCtaEditor';
import { YachtRoutesEditor } from './editors/YachtRoutesEditor';
import { YachtMarinasEditor } from './editors/YachtMarinasEditor';
import { HeaderEditor } from './editors/HeaderEditor';
import { FooterEditor } from './editors/FooterEditor';
import { CustomContentEditor } from './editors/CustomContentEditor';

interface ContentTabProps {
  section: PageSection;
  onUpdateContent: (updates: any) => void;
}

export const ContentTab: React.FC<ContentTabProps> = ({ section, onUpdateContent }) => {
  const normalizedType = (section.type || '').toLowerCase();

  switch (normalizedType) {
    case 'pricing':
      return <PricingEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'hero':
      return <HeroEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'services':
      return <ServicesEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'about':
      return <AboutEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'contact':
      return <ContactEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'yacht_fleet':
      return <YachtFleetEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'yacht_filter':
      return <YachtFilterEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'faq':
      return <FaqEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'testimonials':
      return <TestimonialsEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'gallery':
      return <GalleryEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'stats':
      return <StatsEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'team':
      return <TeamEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'references':
      return <ReferencesEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'reservation_cta':
      return <ReservationCtaEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'yacht_routes':
      return <YachtRoutesEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'yacht_marinas':
      return <YachtMarinasEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'header':
      return <HeaderEditor section={section} onUpdateContent={onUpdateContent} />;
    case 'footer':
      return <FooterEditor section={section} onUpdateContent={onUpdateContent} />;
    default:
      return <CustomContentEditor section={section} onUpdateContent={onUpdateContent} />;
  }
};
